import { gql } from '@apollo/client';

export const QUERY_FETCH_PRICING_LIST = gql`
  query listPricing($input: listPricingInput) {
    listPricing(input: $input) {
      message
      success
      data
    }
  }
`;

export const QUERY_FETCH_PRICING_STATUS = gql`
  query StatusPricing($input: statusPricingInput) {
    statusPricing(input: $input) {
      success
      data
      message
    }
  }
`;

export const QUERY_FETCH_UNIT_TYPE_LIST = gql`
  query ListUnitType($input: listUnitTypeInput) {
    listUnitType(input: $input) {
      message
      success
      data
    }
  }
`;

export const QUERY_FETCH_APPLY_TYPE_LIST = gql`
  query ListApplyType($input: listApplyTypeInput) {
    listApplyType(input: $input) {
      message
      success
      data
    }
  }
`;

export const QUERY_FETCH_RATE_TYPE_LIST = gql`
  query ListRateType {
    listRateType {
      success
      data
      message
    }
  }
`;

export const QUERY_FETCH_OPPORTUNITY_DETAILS = gql`
  query ShowOpportunity($input: showOpportunityInput) {
    showOpportunity(input: $input) {
      message
      success
      data
    }
  }
`;

export const QUERY_FETCH_MILESTONE_DETAILS = gql`
  query ShowOpportunityMilestone($input: showOpportunityMilestoneInput) {
    showOpportunityMilestone(input: $input) {
      progress
      frontProgress
    }
  }
`;

export const QUERY_FETCH_SURCHARGE_LIST = gql`
  query ListSurcharge {
    listSurcharge {
      data
      message
      success
    }
  }
`;

export const QUERY_FETCH_LOCALCHARGE_LIST = gql`
  query ListLocalCharge {
    listLocalCharge {
      success
      data
      message
    }
  }
`;

export const QUERY_ADD_RATE = gql`
  mutation UpdateTransportationAndRate(
    $input: updateTransportationAndRateInput
  ) {
    updateTransportationAndRate(input: $input) {
      success
      data
      message
    }
  }
`;

export const QUERY_FETCH_TRANSPORTATION_DETAILS = gql`
  query showTransportationAndRate($input: showTransportationAndRateInput) {
    showTransportationAndRate(input: $input) {
      message
      success
      data
    }
  }
`;

export const QUERY_FETCH_VENDOR_LIST = gql`
  query listVendor {
    listVendor {
      success
      data
      message
    }
  }
`;

export const QUERY_MARK_TRANSPORTATION_FAV = gql`
  mutation MarkFavouriteTransportation(
    $input: markFavouriteTransportationInput
  ) {
    markFavouriteTransportation(input: $input) {
      success
      data
      message
    }
  }
`;

export const QUERY_SHOW_TRANSPORTATION_HISTORY = gql`
  query ShowTransportationHistory($input: showTransportationAndRateInput) {
    showTransportationHistory(input: $input) {
      success
      data
      message
    }
  }
`;

export const QUERY_UPDATE_OPPORTUNITY_STATUS = gql`
  mutation UpdateOpportunityStatus($input: updateOpportunityStatusInput) {
    updateOpportunityStatus(input: $input) {
      success
      data
      message
    }
  }
`;

export const UPLOAD_DOCUMNET_PRICING = gql`
  mutation Mutation($input: uploadDocumentInput) {
    pricingUploadDocument(input: $input) {
      success
      message
      data
    }
  }
`;

export const RENAME_DOCUMNET_PRICING = gql`
  mutation PricingRenameDocument($input: renameDocumentInput) {
    pricingRenameDocument(input: $input) {
      success
      message
      data
    }
  }
`;

export const GET_ALL_ATTACHMENTS_PRICING = gql`
  query PricingAllAttachment($input: getDocumentsParams) {
    pricingAllAttachment(input: $input) {
      success
      message
      data
    }
  }
`;

export const DELETE_DOCUMENT_PRICING = gql`
  mutation PricingDeleteDocument($input: deleteDocumentInput) {
    pricingDeleteDocument(input: $input) {
      success
      message
      data
    }
  }
`;

export const FOLDER_FILES_PRICING = gql`
  query PricingGetFiles($input: poGetFilesInput) {
    pricingGetFiles(input: $input) {
      success
      data
      message
    }
  }
`;

export const FETCH_PARTICIPANTS_PRICING = gql`
  query ListUserCollab($input: fetchUserCollabInput) {
    listUserCollab(input: $input) {
      success
      data
      message
    }
  }
`;
